import { connect } from 'react-redux'
import { compose, withHandlers, lifecycle, withState, withProps } from 'recompose'
import { bindActionCreators } from 'redux'
import { get } from 'lodash'


import * as InboxActions from 'app/modules/inbox/actions'
import * as InboxSelectors from 'app/modules/inbox/selectors'


import DKIMEmailSettings from './component'


const mapStateToProps = state => ({
  sendingDomains: InboxSelectors.sendingDomains(state),
  isInboxListLoaded: InboxSelectors.isSendingDomainsLoaded(state),
  isInboxListLoading: InboxSelectors.isSendingDomainsLoading(state),
  domainCreateLoading: InboxSelectors.isCreatingDomainLoading(state),
  domainCreateFail: InboxSelectors.isCreatingDomainFailed(state),
  domainCreateFailNoUser: InboxSelectors.isCreatingDomainFailedNoUser(state),
  domainCreateSuccess: InboxSelectors.isCreatingDomainSuccess(state),
})


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchSendingDomains: InboxActions.fetchSendingDomains,
      createSendingDomain: InboxActions.createSendingDomain,
    },
    dispatch
  ),
})


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchSendingDomains()
    },
  }),
  withProps(props => ({
    // we need to load all inboxes and their whitelabels
    isLoading: props.isInboxListLoading,
  })),
  withState('isCreatingDomain', 'setIsCreatingDomain', false),
  withState('sendFromEmail', 'setSendFromEmail', ''),
  withProps(props => ({
    // we need to load all inboxes and their whitelabels
    isLoading: props.isInboxListLoading,
    sendFromDomain: !!props.sendFromEmail && props.sendFromEmail.split('@').length > 1 ? props.sendFromEmail.split('@')[1] : null,
  })),
  withHandlers({
    onAddDomainClick: props => () => {
      props.setIsCreatingDomain(true)
    },
    onSendFromEdit: props => e => {
      props.setSendFromEmail(e.target.value)
    },
    onCancelDomain: props => () => {
      props.setSendFromEmail('')
      props.setIsCreatingDomain(false)
    },
    onSaveDomain: props => () => {
      props.actions.createSendingDomain({
        domain: props.sendFromDomain
      })
    },
  }),
)(DKIMEmailSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/DKIMEmailSettings/index.js